const spacing = (...inputs) =>
  inputs?.length === 0
    ? `0.5rem`
    : inputs
        .slice(0, 4)
        .map((input) => `${input}rem`)
        .join(' ');

export default { spacing };
